import { Injectable } from '@angular/core';
import { IID_PRATICA_IRU_PROVIDER } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { IIDPraticaIruProviderQuery } from './iidPraticaIruProvider.query';
import { IIDPraticaIruProviderStore } from './iidPraticaIruProvider.store';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.IID_PRATICA_IRU_PROVIDER)
export class IIDPraticaIruProviderService extends CrudService<IID_PRATICA_IRU_PROVIDER, IIDPraticaIruProviderStore, IIDPraticaIruProviderQuery> {
  constructor(
    protected store: IIDPraticaIruProviderStore,
    public query: IIDPraticaIruProviderQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy
  ) {
    super(
      Topics.IID_PRATICA_IRU_PROVIDER,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }
}
